/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IActionContext } from '@msdyn365-commerce/core';
import { ICartState } from '@msdyn365-commerce/global-state';
import { ProductDeliveryOptions, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import {
    ActiveCartProductsInput,
    // @ts-expect-error
    getAvailabilitiesForCartLineItems,
    // @ts-expect-error
    getDeliveryOptionsForCartLineItems,
    IProductInventoryInformation,
    // @ts-expect-error
    ProductAvailabilitiesForCartLineItems,
    // @ts-expect-error
    ProductDeliveryOptionsForCartLineItems
} from '@msdyn365-commerce-modules/retail-actions';
import { getActiveCartProductsAction } from './get-products-in-active-cart';

/**
 * IMiniCartData entity interface.
 */
export interface IMiniCartData {
    products?: SimpleProduct[];
    productAvailabilites?: IProductInventoryInformation[];
    deliveryOptions?: ProductDeliveryOptions[];
}

export const createInput = () => {
    return new ActiveCartProductsInput();
};

/**
 * Calls the Retail API and returns a mini cart data.
 * @param ctx
 * @param cartState
 */
export async function getMiniCartData(ctx: IActionContext, cartState: ICartState): Promise<IMiniCartData> {
    const miniCartData: IMiniCartData = {};

    const cart = cartState.cart;

    // If there are cart lines, make call to get products
    // If there are invocie linese, then there is no products, so don't make call to get products
    if (cart && cart.CartLines && cart.CartLines.length > 0 && !cartState.hasInvoiceLine) {
        const productsPromise = getActiveCartProductsAction(new ActiveCartProductsInput(), ctx);
        const availabilityPromise = Promise.resolve(undefined); // getAvailabilitiesForCartLineItems(new ProductAvailabilitiesForCartLineItems(ctx.requestContext.apiSettings), ctx);
        const deliveryOptionsPromise = Promise.resolve(undefined); // getDeliveryOptionsForCartLineItems(new ProductDeliveryOptionsForCartLineItems(ctx.requestContext.apiSettings), ctx);

        await Promise.all([productsPromise, availabilityPromise, deliveryOptionsPromise])
            .then(([products, availability, deliveryOptions]) => {
                if (products) {
                    miniCartData.products = products;
                }
                if (availability) {
                    miniCartData.productAvailabilites = availability;
                }
                if (deliveryOptions) {
                    miniCartData.deliveryOptions = deliveryOptions;
                }
                return miniCartData;
            })
            .catch(error => {
                ctx.telemetry.exception(error);
                throw new Error('[getActiveCartWithProdcuts]Unable to hydrate cart with product information');
            });
    }

    return miniCartData;
}
